// ATTN we use this constants in data dump
const abTests = {
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  homeSpStoryly: 'home:sp:storyly', // CRO-190
  mainStorylyForLeads: 'main:storylyForLeads', // CRO-191
  homeQueueWidget: 'home:queueWidget', // CRO-51
  tyAllUpgradePlans: 'ty:allUpgradePlans', // CRO-130
  tyOnboardingFlow: 'ty:onboardingFlow', // CRO-158
  registerCopyAfterQuizUpdate: 'register:copyAfterQuizUpdate', // CRO-184
  inAppMessagesCenter: 'inAppMessagesCenter', // CRO-69
  paymentBeam: 'payment:beam', // CRO-167
  paymentWithoutAddressAutocomplete: 'payment:withoutAddressAutocomplete', // CRO-145
  paymentDisableLogoLink: 'payment:disableLogoLink', // CRO-170
  paymentRegisterInPayment: 'payment:registerInPayment', // CRO-148
  paymentMarketingMessage: 'payment:marketingMessage', // CRO-155
  saksAddDashHudson: 'saks:addDashHudson', // CRO-137
  homeChangeBannerText: 'home:changeBannerText', // CRO-144
  homeHeroQuizLink: 'home:heroQuizLink', // CRO-151
  homeFaq: 'home:faq', // CRO-180
  homeAnimatedHero: 'home:animatedHero', // CRO-168
  pdpSubscribeOfferCountdown: 'pdp:subscribeOfferCountdown', // CRO-178
  pdpSubscribersCount: 'pdp:subscribersCount', // CRO-187
  spShortVersion: 'sp:shortVersion', // CRO-84
  spSingleBestseller: 'sp:singleBestseller', // CRO-126
  quizButtonsColorChange: 'quiz:buttonsColorChange', // CRO-139
  quizLastStep5sLoading: 'quiz:lastStep5sLoading', // CRO-201
  newReferralProgram: 'newReferralProgram', // EP-2060
  queueStickyBanner: 'queue:stickyBanner', // EP-2100
  queueCaseSubscriptionBanner: 'queue:CaseSubscriptionBanner', // EP-2123
  cancelButton: 'cancelButton25', // EP-2144
  csBadge: 'cs:badge', // EP-2219
  burgerMenu: 'burgerMenu', // EP-2241
  homeCanada50vs60: 'home:canada50vs60', // EP-2181
  upgradeEntryPoints: 'upgradeEntryPoints', // EP-2237
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
